import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: { width: 32, height: 32, textSize: 'text-sm' },
    md: { width: 48, height: 48, textSize: 'text-lg' },
    lg: { width: 64, height: 64, textSize: 'text-2xl' },
  };

  const { width, height } = sizes[size];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Shield background with gradient */}
        <defs>
          <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#4f46e5" />
            <stop offset="50%" stopColor="#4338ca" />
            <stop offset="100%" stopColor="#3730a3" />
          </linearGradient>
          <linearGradient id="checkGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="100%" stopColor="#14f195" />
          </linearGradient>
        </defs>

        {/* Shield shape */}
        <path
          d="M32 4L8 14V28C8 42 16 54 32 60C48 54 56 42 56 28V14L32 4Z"
          fill="url(#shieldGradient)"
          className="drop-shadow-lg"
        />

        {/* Shield border for depth */}
        <path
          d="M32 4L8 14V28C8 42 16 54 32 60C48 54 56 42 56 28V14L32 4Z"
          stroke="white"
          strokeWidth="1.5"
          strokeOpacity="0.3"
          fill="none"
        />

        {/* Lock body */}
        <rect
          x="22"
          y="28"
          width="20"
          height="16"
          rx="2"
          fill="white"
          opacity="0.9"
        />

        {/* Lock shackle */}
        <path
          d="M26 28V22C26 18.7 28.7 16 32 16C35.3 16 38 18.7 38 22V28"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
          opacity="0.9"
        />

        {/* Checkmark overlay */}
        <circle cx="32" cy="36" r="8" fill="url(#checkGradient)" />
        <path
          d="M28.5 36L31 38.5L35.5 34"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Decorative dots */}
        <circle cx="14" cy="18" r="1.5" fill="white" opacity="0.4" />
        <circle cx="50" cy="18" r="1.5" fill="white" opacity="0.4" />
        <circle cx="18" cy="48" r="1.5" fill="white" opacity="0.3" />
        <circle cx="46" cy="48" r="1.5" fill="white" opacity="0.3" />
      </svg>
      {size === 'lg' && (
        <div className="flex flex-col">
          <span className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">
            SecDesk
          </span>
          <span className="text-sm font-medium text-muted-foreground -mt-0.5">
            Access Review
          </span>
        </div>
      )}
      {size === 'md' && (
        <div className="flex flex-col">
          <span className="text-lg font-bold text-indigo-600 dark:text-indigo-400">
            SecDesk
          </span>
          <span className="text-xs font-medium text-muted-foreground -mt-0.5">
            Access Review
          </span>
        </div>
      )}
    </div>
  );
};
